import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["currencySelect", "amountInput", "submitButton"]

  connect() {
    this.updateState()
  }

  updateState() {
    if (!this.hasCurrencySelectTarget || !this.hasAmountInputTarget || !this.hasSubmitButtonTarget) {
      return
    }

    const hasSelectedCurrency = this.currencySelectTarget.value !== ""

    this.amountInputTarget.disabled = !hasSelectedCurrency
    this.submitButtonTarget.disabled = !hasSelectedCurrency

    if (!hasSelectedCurrency) {
      this.amountInputTarget.value = ""
    }
  }
}